import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import FormError from 'components/FormError';
import { transformErrorResponse } from 'helpers/errors';
import { createPurchase, createPurchaseItem } from 'api';

class GenerateMDNChangeFee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      error: undefined,
      purchaseId: undefined,
    };

    this.chargeMDNFee = this.chargeMDNFee.bind(this);
  }

  componentDidMount() {
    this.fetchOverdue();
    this.fetchLeases();
  }

  fetchLeases() {
    const { fetchOwingAction, sub } = this.props;
    fetchOwingAction(sub.id);
  }

  fetchOverdue() {
    const { fetchOverdue, sub } = this.props;
    const { user_profile } = sub;
    fetchOverdue(user_profile);
  }

  async chargeMDNFee() {
    const { sub, fetchOwing } = this.props;
    const { user_profile } = sub;

    const confirm = window.confirm(
      `Are you sure you want to charge a MDN fee to user ${user_profile}?`,
    );
    if (!confirm) {
      return;
    }

    try {
      const fetchResponse = await fetchOwing(sub.id, 1, { outstanding: true });
      const { results: leases } = fetchResponse.data;

      if (leases.length > 0) {
        this.fetchLeases();
        return;
      }

      const { data, status } = await createPurchase(user_profile);

      if (status === 200 || status === 201) {
        const { id } = data;
        const productId = 666;
        const productType = 'product';
        const response = await createPurchaseItem(id, productId, productType);

        if (response.status === 200 || response.status === 201) {
          this.setState({
            isSent: true,
            purchaseId: id,
          });
        }
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        isSent: false,
      });
    }
  }

  render() {
    const { isSent, error, purchaseId } = this.state;
    const { overdue, leases } = this.props;
    const isNotOverdue = overdue.length === 0;
    const isNotOwed = leases.length === 0;
    const isAllowed = isNotOverdue && isNotOwed;

    return (
      <div className="mar-b">
        <button
          className="btn btn-primary"
          disabled={!isAllowed || isSent}
          onClick={this.chargeMDNFee}
        >
          Charge MDN Fee
        </button>
        {error ? <FormError error={error} /> : null}
        {!isNotOwed ? (
          <div className="text-danger">
            - Subscription has a lease that needs to be transferred.
          </div>
        ) : null}
        {!isNotOverdue ? (
          <div className="text-danger">
            - User has overdue purchases that must be paid:
            <ul>
              {overdue.map((purchase) => (
                <li key={purchase.id}>
                  <Link to={`/purchases/${purchase.id}/view`}>
                    Purchase #{purchase.id}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        {isSent ? (
          <div className="text-success">
            MDN change fee invoice successfully generated. View{' '}
            {
              <Link to={`/purchases/${purchaseId}/view`}>
                Purchase #{purchaseId}
              </Link>
            }
          </div>
        ) : null}
      </div>
    );
  }
}

export default GenerateMDNChangeFee;
